import {
	Component,
	EventEmitter,
	Input,
	Output,
	OnInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { PRIORITY_LEVELS } from '@app/pages/cmms/configs/priority-levels';

import { AuPriorityLevelComponent } from '@shared/ui-components/au-priority-level/au-priority-level.component';
import { MatMenuModule } from '@angular/material/menu';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'cmms-priority-level',
	templateUrl: './cmms-priority-level.component.html',
	styleUrls: ['./cmms-priority-level.component.scss'],
	imports: [MatMenuModule, AuPriorityLevelComponent, NgxTolgeeModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CmmsPriorityLevelComponent implements OnInit {
	readonly defaultPriorityLevel = 2;

	@Input() set priorityLevel(level: number) {
		this.formControl.setValue(level);
	}
	@Output() priorityLevelChanged = new EventEmitter<{ priority: number }>();
	@Output() controlReady = new EventEmitter<FormControl>();

	formControl = new FormControl(this.defaultPriorityLevel);

	priorityList = PRIORITY_LEVELS;

	constructor(private cdr: ChangeDetectorRef) {}

	ngOnInit(): void {
		this.controlReady.emit(this.formControl);
		this.formControl.valueChanges.subscribe(() => {
			this.cdr.detectChanges();
		});
	}

	setPriority(level: number): void {
		this.formControl.setValue(level, {
			emitEvent: false,
		});

		this.priorityLevelChanged.emit({ priority: level });
	}
}
